import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-cierre-sesion',
  templateUrl: './modal-cierre-sesion.component.html',
  styleUrls: ['./modal-cierre-sesion.component.scss'],
  standalone: false,
})
export class ModalCierreSesionComponent {
  constructor(public modalControlador: ModalController) {}

  cancel() {
    this.modalControlador.dismiss(false);
  }

  ok() {
    this.modalControlador.dismiss(true);
  }
}
